import { fetchError, fetchRequest, fetchSuccess} from "./actions";
import { fetch} from "../../repo/emv";
import { isEmpty} from "ramda";
import { isAuthError} from "../index";
import { put, takeEvery} from "redux-saga/effects";
import { dirty } from "../session/actions";
import { EmvActionTypes } from "./types";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const emv = yield fetch(action.payload.id, action.payload.params);
    if (emv.errors && !isEmpty(emv.errors)) {
      if (isAuthError(emv.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(emv.errors)));
    } else {
      yield put(fetchSuccess(emv));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(EmvActionTypes.FETCH, handleFetch);
}

export default watchFetchRequest;
